<template>
  <span style="word-break: break-word" class="notranslate" translate="no">{{ userfullname }}</span>
  <!-- <span :style="userColor" >{{ userfullname }}</span> -->
</template>

<script>
export default {
  props: {
    row: Object,
    column: Object,
  },
  computed: {
    userfullname() {
      if (!this.row || !this.row[this.column.name]) {
        return this.column.default || "";
      }

      let userfullname = this.row[this.column.name].toUpperCase();

      if (this.row[this.column.nickname]) {
        userfullname += " (" + this.row[this.column.nickname] + ")";
      }

      return userfullname;
    },
    userColor(){
      let userColor = "";
      if (!this.row || !this.row['user_color']) {
        userColor = {color:'#1168a8','word-break': 'break-word'};
      }else{
        if(this.row['user_color'] == "#000000"){
          userColor = {color:'#1168a8','word-break': 'break-word'};
        }else{
          userColor = {color:this.row['user_color'],'word-break': 'break-word'};
        }
      }

      // userColor = {color:'#551245','word-break': 'break-word'}
      return userColor;
    }
  },
};
</script>
